var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Condiciones de Cumplimiento" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c(
        "v-container",
        {
          staticClass: "pa-0",
          staticStyle: { "padding-top": "0px" },
          attrs: { fluid: "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md11: "" } },
                [
                  _c(
                    "h2",
                    {
                      staticClass: "h2_title mb-1",
                      staticStyle: {
                        "text-align": "center",
                        "margin-left": "0",
                        "padding-left": "0",
                        "font-weight": "normal",
                        "margin-top": "40px"
                      }
                    },
                    [
                      _vm._v(
                        "\n          Información de Cumplimientos\n        "
                      )
                    ]
                  ),
                  _c("v-divider"),
                  _c("MantenedorGridVerDetalle", {
                    attrs: { "grid-options": _vm.gridOptions },
                    on: {
                      gridOptionsEnriched: function($event) {
                        _vm.enrichedGridOptions = $event
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }